import dayjs from 'dayjs';
import { addNotify } from 'features/notify';


import { actions } from 'features/Auth';
import { actions as treeActions } from 'features/tree';

import { getErrorMessage } from 'shared/helpers/getErrorMessage';
import { stringToNumberOrZero } from 'shared/helpers';

const actionTypes = {
  ACTION_PROCESSING: 'user/ACTION_PROCESSING',
  CREATE_USER_SUCCESS: 'user/CREATE_USER_SUCCESS',
  GET_USERS_LIST_SUCCESS: 'user/GET_USER_LIST_SUCCESS',
  GET_USERS_LIST_FAILED: 'user/GET_USER_LIST_FAILED',
  RESET_PASSWORD_SUCCESS: 'user/RESET_PASSWORD_SUCCESS',
  GET_USER_INFO_SUCCESS: 'user/GET_USER_INFO_SUCCESS',
  USER_INFO_DELETE: 'user/USER_INFO_DELETE',
  DATA_REFRESH: 'user/DATA_REFRESH',
  GET_BANNED_PROVIDERS: 'user/GET_BANNER_PROVIDERS',
  SET_BANNED_PROVIDERS: 'user/SET_BANNER_PROVIDERS',
  GET_PROFILE_INFO: 'user/GET_PROFILE_INFO',
  GET_SETTING_LIMITS_INFO: 'user/GET_SETTING_LIMITS_INFO',
};

function createUser({ form, callback }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;
    const { username, password, email, name, surname } = form;
    const requestBody = {
      username,
      password,
      email,
      first_name: name,
      last_name: surname,
      role: 0, // роль для создания юзера
    };

    if (requestBody.password.length < 1 || requestBody.username.length < 1) {
      dispatch(addNotify('Password and username shoud not be empty', 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    } else {
      const response = await api.user.createUser(requestBody);
      if (response.success) {
        dispatch(addNotify(locale.createSuccess, 'success'));
        dispatch({ type: actionTypes.CREATE_USER_SUCCESS });
        dispatch({ type: actionTypes.DATA_REFRESH, payload: true });
        callback && callback();
      } else {
        const errorMessage = getErrorMessage(locale, response);
        dispatch(addNotify(errorMessage, 'error'));
        dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
      }
    }
  };
}

function createAgent({ form, callback }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;
    const {
      username,
      password,
      email,
      name,
      surname,
      withdrawalAllowed,
      onlyPlayerCreationAllowed,
      depositAllowed,
      commission,
      /* semiAutomaticPayment, */
    } = form;
    const requestBody = {
      username,
      password,
      email,
      first_name: name,
      last_name: surname,
      is_withdrawal_access: withdrawalAllowed,
      is_deposit_access: depositAllowed,
      can_create_only_player: onlyPlayerCreationAllowed,
      commission_percent: commission,
      role: 6,
      /* semi_auto_withdrawal_enabled: semiAutomaticPayment, */
    };

    if (requestBody.password.length < 1 || requestBody.username.length < 1) {
      dispatch(addNotify('password and username shoud not be empty', 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    } else {
      const response = await api.user.createUser(requestBody);
      if (response.success) {
        dispatch(addNotify(locale.createSuccess, 'success'));
        dispatch({ type: actionTypes.CREATE_USER_SUCCESS });
        dispatch({ type: actionTypes.DATA_REFRESH, payload: true });
        callback && callback();
      } else {
        const errorMessage = getErrorMessage(locale, response);
        dispatch(addNotify(errorMessage, 'error'));
        dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
      }
    }
  };
}

function getUsersList(filterData, withName = false) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const response = await api.user.getUsersList(filterData);

    if (response.success) {
      const parentUser = response.data?.users?.[0];

      dispatch({
        type: actionTypes.GET_USERS_LIST_SUCCESS,
        payload: response.data,
      });
      return withName ? { id: parentUser?.id, username: parentUser?.username } : parentUser?.id;
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
      dispatch({ type: actionTypes.GET_USERS_LIST_FAILED });
      // return new Promise();
    }
  };
}

function changeBanState(id, value) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;
    const response = await api.user.changeBanState(id, value);
    const text = value ? locale.banSuccess : locale.unbanSuccess;
    if (response.success) {
      dispatch(addNotify(text, 'success'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };
}

function resetPassword(id, callback, new_password) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;
    const response = await api.user.resetPassword(id, new_password);
    if (response.success) {
      callback(true);
      dispatch(addNotify(locale.resetSuccess, 'success'));
      dispatch({
        type: actionTypes.RESET_PASSWORD_SUCCESS,
        payload: response.data,
      });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };
}

function changeUserBalance(id, amount, isOutcome, callback) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;
    const response = await api.user.changeUserBalance(id, amount, isOutcome);
    if (response.success) {
      dispatch(getUsersList());
      callback('');
      dispatch(addNotify(isOutcome ? locale.withdrawalSuccess : locale.topUpSuccess, 'success'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };
}

function depositOrWithdrawal({ amount, operation, id, callback, bonusAmount, bonusPercentAmount, isBonus }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;
    const requestBody = {
      amount,
      operation, // 0 - deposit, 1 - withdrawal
      id,
      bonusAmount,
      bonusPercentAmount,
      isBonus,
    };

    if (!requestBody.amount && requestBody.amount !== 0) {
      dispatch(addNotify('amount should not be empty', 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    } else {
      const response = await api.user.depositOrWithdrawal(requestBody);
      if (response.success) {
        dispatch(addNotify(locale.createSuccess, 'success'));
        dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
        callback && callback();
      } else {
        const errorMessage = getErrorMessage(locale, response);
        dispatch(addNotify(errorMessage, 'error'));
        dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
      }
    }
  };
}

function changePassword({ data, id, callback }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;
    const isCurrentUser = +id === +getState().auth.id;

    if (data.password.length < 1) {
      dispatch(addNotify('password shoud not be empty', 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    } else {
      const response = await api.user.changeUserInfo({ data, id });
      if (response.success) {
        dispatch(addNotify(locale.createSuccess, 'success'));
        dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
        dispatch(actions.checkAuth());
        callback && callback();
      } else {
        const errorMessage = isCurrentUser && response.codeStatus === 4
          ? locale.invalidOldPassword
          : getErrorMessage(locale, response);
        dispatch(addNotify(errorMessage, 'error'));
        dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
      }
    }
  };
}

function disableUser({ data, id, callback }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;

    const response = await api.user.changeUserInfo({ data, id });
    if (response.success) {
      dispatch(addNotify(locale.createSuccess, 'success'));
      dispatch({ type: actionTypes.DATA_REFRESH, payload: true });
      callback && callback();
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };
}

function modifyAgent({ data, id, callback }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;

    const requestBody = {
      first_name: data.name,
      last_name: data.surname,
      email: data.email,
      commission_percent: data.commission,
      is_withdrawal_access: data.withdrawalAllowed,
      is_deposit_access: data.depositAllowed,
      can_create_only_player: data.onlyCreatePlayer,
      semi_auto_withdrawal_enabled: data.semiAutomaticPayment,
    };

    const response = await api.user.changeUserInfo({ data: requestBody, id });
    if (response.success) {
      dispatch(addNotify(locale.createSuccess, 'success'));
      dispatch({ type: actionTypes.DATA_REFRESH, payload: true });
      callback && callback();
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };
}

function getUserInfo({ id, callback, withParent = false }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;

    const response = await api.user.getUserInfo({ id });
    if (response.success) {
      const parentAgentId = response.data?.parentAgentId;

      let parentInfo = {};

      if (withParent && parentAgentId) {
        const responseParent = await api.user.getUserInfo({ id: parentAgentId });
        if (responseParent.success) {
          parentInfo = responseParent.data;
        }
      }

      response.data.parentInfo = parentInfo;

      dispatch({
        type: actionTypes.GET_USER_INFO_SUCCESS,
        payload: response.data,
      });

      callback && callback();
    } else {
      const { locale } = getState().locale;
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };
}

function deleteUserInfo() {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    dispatch({
      type: actionTypes.USER_INFO_DELETE,
    });
  };
}

function getBannedProviders({ id, callback }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;

    const response = await api.user.getBannedProviders({ id });
    if (response.success) {
      dispatch({
        type: actionTypes.GET_BANNED_PROVIDERS,
        payload: response.data,
      });
      callback && callback();
    } else {
      const { locale } = getState().locale;
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };
}

function setBannedProviders({ data, callback }) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const { locale } = getState().locale;

    const withPragmatic = data.providers?.includes('pragmatic');
    let response;

    if (withPragmatic) {
      const isAlone = data.providers?.length === 1;
      const providers1 = isAlone ? ['pragmatic-rgs'] : data.providers?.filter(v => v !== 'pragmatic').concat(['pragmatic-rgs']);
      const providers2 = isAlone ? ['pragmatic'] : data.providers?.filter(v => v !== 'pragmatic-rgs');

      const pragmaticResponse1 = await api.user.setBannedProviders({ data: { ...data, providers: providers1 }});
      const pragmaticResponse2 = await api.user.setBannedProviders({ data: { ...data, providers: providers2 }});
      response = [pragmaticResponse1, pragmaticResponse2].find(v => v.success) ?? pragmaticResponse1;
    } else {
      response = await api.user.setBannedProviders({ data });
    }

    if (response.success) {
      callback && callback();
      dispatch(getBannedProviders({ id: data.id }));
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };
}

const getUsersListForSearch =
  ({ username, isDirectStructure, callback }) =>
  async (dispatch, getState, extra) => {
    const { api } = extra;
    const { canCreateOnlyPlayer } = getState().auth;
    const finalIsDirectStructure = canCreateOnlyPlayer ? true : isDirectStructure;

    const response = await api.user.searchUsers({ username, is_direct_structure: finalIsDirectStructure });

    if (response.success) {
      if (callback) callback(response.data);
    } else {
      const errorMessage = getErrorMessage(getState().locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }
  };

const searchUsers =
  ({ filterData, callback }) =>
  async (dispatch, getState, extra) => {
    const { api } = extra;
    const { id: currentId, canCreateOnlyPlayer } = getState().auth;

    let result = currentId;

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const response = await api.user.searchUsers({ username: filterData.username, is_direct_structure: canCreateOnlyPlayer ? true : undefined });

    if (response.success) {
      const id = response.data?.id;
      if (id !== undefined) result = id;

      await dispatch(
        treeActions.getUsersByUserId({
          nesting: [],
          id,
          username: filterData.username,
          withParents: true,
        }),
      );

      await dispatch(treeActions.changeTargetUser({ id: Number(id) }));

      // dispatch({
      //   type: actionTypes.GET_USERS_LIST_SUCCESS,
      //   payload: response.data,
      // });
      if (callback) callback(response.data);
    } else {
      const errorMessage = getErrorMessage(getState().locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });

    return result;
  };

function getProfileInfo({ callback } = {}) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;
    const response = await api.user.getProfileInfo();

    if (response.success) {
      dispatch({
        type: actionTypes.GET_PROFILE_INFO,
        payload: response.data,
      });
      callback && callback();
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }
  };
}

function getSettingLimitsInfo() {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;
    const response = await api.user.getSettingLimitsInfo();

    if (response.success) {
      dispatch({
        type: actionTypes.GET_SETTING_LIMITS_INFO,
        payload: response.data,
      });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }
  };
}

function setSettingLimits(data, callback) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;

    const normalized = {
      minimumDeposit: stringToNumberOrZero(data.minimumDeposit),
      minimumWithdrawal: stringToNumberOrZero(data.minimumWithdrawal),
    };

    const response = await api.user.setSettingLimits(normalized);

    if (response.success) {
      dispatch(addNotify(locale.createSuccess, 'success'));

      callback && callback();
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }
  };
}

export {
  actionTypes,
  createUser,
  getUsersList,
  changeBanState,
  resetPassword,
  changeUserBalance,
  createAgent,
  depositOrWithdrawal,
  changePassword,
  disableUser,
  getUserInfo,
  deleteUserInfo,
  modifyAgent,
  getBannedProviders,
  setBannedProviders,
  searchUsers,
  getUsersListForSearch,
  getProfileInfo,
  getSettingLimitsInfo,
  setSettingLimits,
};
